import React from 'react';

import { Alert, Button, Result } from 'antd';

/**
 * Компонент для отображения ошибок Module Federation
 */
export const ModuleFederationError = ({ error, moduleName, onRetry }) => {
  const isNetworkError =
    error?.message?.includes('fetch') ||
    error?.message?.includes('network') ||
    error?.message?.includes('NetworkError') ||
    error?.message?.includes('CONNECTION_REFUSED') ||
    error?.message?.includes('недоступен');

  const isDevelopment = import.meta.env?.MODE === 'development';

  const getErrorTitle = () => {
    if (isNetworkError) {
      return 'Удаленный модуль недоступен';
    }
    return `Не удалось загрузить модуль ${moduleName}`;
  };

  const getErrorDescription = () => {
    if (isNetworkError && isDevelopment) {
      return (
        <div>
          <p>Убедитесь, что сервер d360v2 запущен </p>
          <p>Проверьте:</p>
          <ul style={{ textAlign: 'left', marginLeft: '20px' }}>
            <li>Сервер d360v2 запущен и работает</li>
            <li>Порт 5000 доступен</li>
            <li>CORS настроен правильно</li>
            <li>Путь /module_federation/remoteEntry.js существует</li>
          </ul>
        </div>
      );
    }
    if (isNetworkError) {
      return 'Проверьте подключение к интернету и доступность удаленного сервера';
    }
    return 'Возникла ошибка при загрузке удаленного модуля';
  };
  return (
    <div style={{ padding: '50px 20px', textAlign: 'center' }}>
      <Result
        status='warning'
        title={getErrorTitle()}
        subTitle={getErrorDescription()}
        extra={[
          <Button type='primary' key='retry' onClick={onRetry}>
            Попробовать снова
          </Button>,
          <Button key='home' onClick={() => (window.location.href = '/')}>
            На главную
          </Button>,
        ]}
      />

      {isDevelopment && (
        <Alert
          type='error'
          showIcon
          style={{ marginTop: '20px', textAlign: 'left' }}
          message='Детали ошибки (только в режиме разработки)'
          description={
            <pre style={{ fontSize: '12px', overflow: 'auto' }}>{error?.stack || error?.message || String(error)}</pre>
          }
        />
      )}
    </div>
  );
};

export default ModuleFederationError;
